






































































































































import { Component, Vue, Watch, Provide } from 'vue-property-decorator';
import { timeFormat } from "@/utils/index.ts";
import { nxExtenManageClient } from "@/api/index";
import { OperateNxteleReq, NxteleListReq } from "@/pbjs/xcommon/nxExtenManage_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage } from "@/utils/request";

@Component({
  name: 'CombinationProperty'
})
export default class CombinationProperty extends Vue {
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private systemInfo: any = localStorage.getItem("systemInfo"); // 国家，字段差异化展示
  @Provide() private resultData: any = [];
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private searchText: string = "";
  @Provide() private operation: any = [];
  @Provide() private logicOperation: any = [];
  @Provide() private onOperateValues: string[] = [];
  @Provide() private basicAttrOptions: any = [];
  @Provide() private basicAttrList: any = [];
  @Provide() private basicAttrMap: any = new Map();
  @Provide() private isShowAttrValue: boolean = false;
  @Provide() private isShowCombValue: boolean = false;
  @Provide() private combFirstValueOptions: any = [];
  @Provide() private typeInput: boolean = true;
  @Provide() private operate: any = 1;
  @Provide() private editId: any = '';
  @Provide() private attrValueForm: any = {
    name: "",
    appKey: "",
    secretKey: "",
    belong: "1",
    salt: "",
    companyCode: "",
    systemType:'',
    systemTypeList:'',
  };
  @Provide() private belongOptions: any = [
    {
      value: '1',
      label: 'nxtele',
    },
    {
      value: '2',
      label: 'infinity',
    },
    // {
    //   value: '3',
    //   label: 'tata',
    // },
    // {
    //   value: '4',
    //   label: 'cmc',
    // },
    // {
    //   value: '6',
    //   label: 'wscrm',
    // },
    // {
    //   value: '7',
    //   label: 'sti',
    // },
    // {
    //   value: '8',
    //   label: 'symphony',
    // },
    // {
    //   value: '10',
    //   label: "asterisk"
    // },
    // {
    //   value: '11',
    //   label: 'calluCloud',
    // },
    {
      value: '14',
      label: 'MG Call',
    },
  ];
  @Provide() private belongOpts: any = {
    '1': 'nxtele',
    '2': 'infinity',
    // '3': 'tata',
    // '4': 'cmc',
    // '6': 'wscrm',
    // "7":"sti",
    // "8":"symphony",
    // "10":"asterisk",
    // "11": "calluCloud",
    "14": "MG Call"
  }
  @Provide() private belongIndiaOpts: any = {
    '1': 'Chan-2',
    '2': 'Chan-3',
    '3': 'Chan-1',
    '4': 'cmc',
    "7":"sti",
    "8":"symphony"
  }
  @Provide() private systemTypeOpts: any = [
    {
      value: '0',
      label: '催收'
    },
    {
      value: '1',
      label: '电核'
    },
    {
      value: '2',
      label: '电销'
    }
  ]
  @Provide() private combForm: any = {
    combLoginName: "",
    combFirstValue: "",
    combination: [{operation: "", input: ""}],
  };
  @Provide() private attrValueRules: any = {
    name: [{ required: true, message: '请输入', trigger: 'blur' }],
    appKey: [{ required: true, message: '请输入', trigger: 'blur' }],
    secretKey: [{ required: true, message: '请输入', trigger: 'blur' }],
    belong: [{ required: true, message: '请输入', trigger: 'blur' }],
  }
  @Provide() private combRules: any = {
    combLoginName: [{ required: true, message: '请输入', trigger: 'blur' }],
    combFirstValue: [{ required: true, message: '请输入', trigger: 'blur' }]
  }
  @Provide() private pagnition: any = pagnition;

  private created() {
    this.getTicketAttrs()
  }

  private handleCurrentChange(val: any){
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketAttrs();
  }

  //点击上一页
  private handlePrevChange(val: any){
    if(this.pageIndex>0){
      //展示表格数据
      this.getTicketAttrs();
    }
  }

  //点击下一页
  private handleNextChange(val: any){
    //展示表格数据
    this.getTicketAttrs();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    this.pageIndex = 1;
    //展示表格数据
    this.getTicketAttrs();
  }

  private resetForm(formName: string) {
    let ref: any = this.$refs[formName];
    if (ref) {
      ref.resetFields();
    }
  }

  private submitForm() {
    let formName: string = "attrValueForm";
    let ref: any = this.$refs[formName];
    ref.validate((valid: any) => {
      if (valid) {
        this.saveTicketAttr();
      } else {
        return false;
      }
    });
  }

  private searchCombValue() {
    this.pageIndex = 1;
    this.getTicketAttrs();
  }

  private addAttrValueOperation(flag: boolean) {
    this.isShowAttrValue = flag;
    this.resetForm('attrValueForm');
  }

  // 列表编辑
  private editCombination(row: any) {
    this.isShowAttrValue = true;
    this.attrValueForm.name = row.name;
    this.attrValueForm.appKey = row.appkey;
    this.attrValueForm.secretKey = row.secretkey;
    this.attrValueForm.belong = row.belong + '';
    this.attrValueForm.salt = row.salt;
    this.attrValueForm.companyCode = row.companycode;
    this.attrValueForm.systemType = row.systemtype;
    this.attrValueForm.systemTypeList = row.systemtype.length>0?row.systemtype.split(","): '' ;
    this.editId = row.id;
    this.operate = 2;

  }

  // 新增-提交
  private async saveTicketAttr() {   // 1:添加 2:修改
    const { setOperateNxteleReq, getOperateNxteleRequest }: any = await import("@/request/getNxteleList");
    let res = await getOperateNxteleRequest.handleHttp(setOperateNxteleReq({
      operate: this.operate,
      editId: this.editId,
      attrValueForm: {
        name: this.attrValueForm.name,
        appKey:  this.attrValueForm.appKey,
        secretKey:  this.attrValueForm.secretKey,
        belong:  this.attrValueForm.belong,
        salt:  this.attrValueForm.salt,
        companyCode:  this.attrValueForm.companyCode,
        // systemType:this.attrValueForm.systemType,
        systemType:this.attrValueForm.systemTypeList.length>0? this.attrValueForm.systemTypeList.join(','):"",
      }
    }), null);
    if (res && res.right) {
      this.getTicketAttrs();
      this.operate = 1;
      this.$message({
        message: 'submit successfully',
        type: 'success'
      });
      this.resetForm("attrValueForm");
    } else {
      this.$message.error(res.commonout.errmsg);
    }
  }
  // private saveTicketAttr() {  // 1:添加 2:修改
  //   let request:any = new OperateNxteleReq();
  //   request.setCommonin(setCommon());
  //   request.setOperate(this.operate);
  //   request.setName(this.attrValueForm.name);
  //   request.setAppkey(this.attrValueForm.appKey);
  //   request.setSecretkey(this.attrValueForm.secretKey);
  //   request.setBelong(this.attrValueForm.belong);
  //   request.setSalt(this.attrValueForm.salt);
  //   request.setId(this.editId);
  //   nxExtenManageClient.operateNxtele(request, {}, (err: any, response:any) => {
  //     if(response) {
  //       let data:any = response.toObject();
  //       if (!data.commonout || (data.commonout.code == 0)) {
  //         this.getTicketAttrs();
  //         this.operate = 1;
  //         this.$message({
  //           message: '提交成功',
  //           type: 'success'
  //         });
  //         this.resetForm("attrValueForm");
  //       } else {
  //         this.$message.error(data.commonout.errmsg);
  //       }
  //     }
  //     if (err) {
  //       errorMsg(err);
  //     }
  //   });
  // }

  // 获取当前列表
  private async getTicketAttrs() {
    const { setNxteleListReq, getNxteleListRequest }: any = await import("@/request/getNxteleList");
    let res = await getNxteleListRequest.handleHttp(setNxteleListReq({
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
    }), null);
    if (res && res.right) {
      let list = res.nxtelelistList;
      list.forEach((item: any) => {
        // item.belongs = this.belongOpts[item.belong];
        item.belongs = this.country === 'in' ? this.belongIndiaOpts[item.belong]:this.belongOpts[item.belong];
        let arr: any = [];
        
        if (item.systemtype.length>0) {
          item.systemtype.split(",").forEach((n: any,m:number) => {
          if (n=="1"||n=="0"||n=="2") {
            let str= this.systemTypeOpts[n].label
            arr.push(str)
          }
          item.systemtypeStr = arr.join(",");
        }); 
        }
        
        item.ctime = timeFormat(item.ctime);
        item.utime = timeFormat(item.utime);
      });
      this.resultData = list;
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
  // private getTicketAttrs() {
  //   let request:any = new NxteleListReq();
  //   request.setCommonin(setCommon());
  //   request.setPagein(setPage(this.pageIndex, this.pageSize));
  //   request.setName('');
  //   request.setAppkey('');
  //   request.setSecretkey('');
  //   request.setBelong('');
  //   nxExtenManageClient.nxteleList(request, {}, (err: any, response:any) => {
  //     if(response) {
  //       let data:any = response.toObject();
  //       if (!data.commonout || (data.commonout.code == 0)) {
  //         this.pagerCount = data.pageout.total;
  //         let list = data.nxtelelistList;
  //         list.forEach((item: any) => {
  //           item.belongs = this.belongOpts[item.belong];
  //           item.ctime = timeFormat(item.ctime);
  //           item.utime = timeFormat(item.utime);
  //         });
  //         this.resultData = list;
  //       } else {
  //         this.$message.error(data.commonout.errmsg);
  //       }
  //     }
  //     if (err) {
  //       errorMsg(err);
  //     }
  //   });
  // }
}
